// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.vacp-color-input-group {\n    display: none !important;\n}\n.vacp-copy-button {\n    display: none !important;\n}\n.expenses {\n    color: red\n}\n.incoming {\n    color: green\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
